import React, { useState } from 'react'
import { useTheme } from '../../provider/ThemeProvider'
import { ButtonLink, P } from '../../styles/Elements'
import StandardVerticalSpace from '../../styles/StandardVerticalSpace'
import Button from '../Button'
import { CancelButtonWarningText } from './styles'

interface CancelButtonProps {
  action: () => Promise<void>
  buttonText: React.ReactChild
  cancelMessage: React.ReactChild
  defaultMessage: React.ReactChild
  unmounted?: boolean
}

const ConfirmedAction: React.FC<CancelButtonProps> = ({
  defaultMessage,
  buttonText,
  cancelMessage,
  action,
  unmounted = false,
}) => {
  const { theme } = useTheme()

  const [confirm, setConfirm] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleClick = async () => {
    if (!confirm) {
      setConfirm(true)
    } else {
      setLoading(true)
      await action()

      if (!unmounted) {
        setLoading(false)
        setConfirm(false)
      }
    }
  }

  const cancel = (
    <P>
      <ButtonLink onClick={() => setConfirm(true)}>{defaultMessage}</ButtonLink>
    </P>
  )

  const confirmCancel = (
    <div>
      <div>
        <Button
          theme={theme}
          onClick={handleClick}
          loading={loading}
          disabled={loading}
          uppercase
        >
          {buttonText}
        </Button>
      </div>
      {!loading && (
        <>
          <StandardVerticalSpace />
          <CancelButtonWarningText>
            <P>
              <ButtonLink onClick={() => setConfirm(false)}>
                <strong>{cancelMessage}</strong>
              </ButtonLink>
            </P>
          </CancelButtonWarningText>
        </>
      )}
    </div>
  )

  return confirm ? confirmCancel : cancel
}

export default ConfirmedAction
